import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconArLabel$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconArLabel extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '8145edb722166a904d3e051b9eaba85c0d46ffec', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '2d82934d1234e93499ba588de47e0f56cd95e5c0', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '51cec50c1a5cd1a28dc892e6177b812fdea2392e', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M9.48 13.336H6.972l-.485 1.414H5L7.468 8h1.507l2.458 6.75H9.946zm-2.15-1.093h1.793l-.902-2.829zM12.354 8h2.319q.545 0 .976.15.432.15.739.427.308.276.47.677.165.4.164.902 0 .693-.307 1.184a1.9 1.9 0 0 1-.872.742l1.635 2.668h-1.635l-1.438-2.447h-.634v2.447h-1.417zm2.27 3.15q.465 0 .728-.261t.263-.723q0-.45-.258-.707-.258-.255-.734-.255h-.862v1.945z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-ar-label", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-ar-label"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-ar-label":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconArLabel$1);
            }
            break;
    } });
}

const CosmosIconArLabel = CosmosIconArLabel$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconArLabel, defineCustomElement };
